import DeliveryDetail from './DeliveryDetail'

export default DeliveryDetail